var exports = {
  "m": "Wrapper__EMIlt0",
  "H": "Canvas__hkCneK",
};

module.exports = exports;
